import type { CurrentUser } from '@wundo/client/auth.ts';
import { personName } from '@/lib/personName.ts';

/* The initials stand-in needs something to abbreviate; an address will do. */
export function nameToAbbreviate(user: CurrentUser): string {
  return personName(user);
}
